var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.showModalTitulo
        ? _c("app-modal-selecionar-modelo-notificacao", {
            attrs: {
              tiposModelo: [_vm.formOptions.tipoModelo],
              idProcesso: _vm.formOptions.despacho.idProcesso,
              titulo: "Modelos de Título",
              showModal: _vm.showModalTitulo
            },
            on: {
              closeModal: _vm.fecharModalTitulo,
              setTextoTitulo: _vm.setTextoDespacho
            }
          })
        : _vm._e(),
      !_vm.schema.removeTitle
        ? _c(
            "div",
            { staticClass: "flex-despacho" },
            [
              _vm.isAmapa || _vm.isMa
                ? _c("p", { staticClass: "label-nao-obrigatoria" }, [
                    _vm._v("Informações para Registro do Imóvel: ")
                  ])
                : _c("p", { staticClass: "label" }, [
                    _vm._v("Informações para Registro do Imóvel: ")
                  ]),
              _vm.showModelo
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.openModalTitulo }
                    },
                    [
                      _vm._v("Modelo  "),
                      _c("div", { staticClass: "fa fa-file" })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.model &&
      (_vm.model[_vm.schema.inputName] ||
        _vm.model[_vm.schema.inputName] === "" ||
        (_vm.model.portaria &&
          (_vm.model.portaria.memorialDescritivo ||
            _vm.model.portaria.memorialDescritivo === "")))
        ? _c("app-editor-texto", {
            ref: "editorTexto",
            staticClass: "margin-input",
            class: { erro: _vm.errors.length },
            attrs: { readonly: _vm.schema.readonly, value: _vm.getTextValue },
            on: { onTextChange: _vm.onTextChange }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81865dca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81865dca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppTextArea.vue
// module id = null
// module chunks = 